import { useLocalSearchParams } from 'expo-router';
import React, { useState } from 'react';
import PillGroup from 'shared/components/vxl/navigation/PillGroup/PillGroup';
import { useViewDidFocusScreenAnalyticsEvent } from 'shared/hooks/analytics/useViewDidFocusAnalytics';

import ExternalCards from './ExternalCards';
import LinkedExternalAccounts from './LinkedExternalAccounts';

interface ExternalTypeTabProps {
  id: string;
  labelText: string;
}

const externalTypePillsData = [
  { id: 'cards', labelText: 'Cards' },
  { id: 'accounts', labelText: 'Accounts' },
];

export const accountsPill = externalTypePillsData[1].id;
export const cardsPill = externalTypePillsData[0].id;

const ExternalTypeSelectionScreen = () => {
  useViewDidFocusScreenAnalyticsEvent({
    key: 'linked-cards-and-accounts',
    customAttributes: { flow_name: 'card_management' },
  });

  const { tab } = useLocalSearchParams();
  const accountSelected = tab === accountsPill;
  const [selectedTab, setSelectedTab] = useState(
    accountSelected ? accountsPill : cardsPill,
  );

  return (
    <>
      <PillGroup
        key={selectedTab}
        initialSelectedPillId={selectedTab}
        pillConfigs={externalTypePillsData}
        onSelection={(externalData: ExternalTypeTabProps) => {
          setSelectedTab(externalData.id);
        }}
      />
      {selectedTab === accountsPill ? (
        <LinkedExternalAccounts />
      ) : (
        <ExternalCards />
      )}
    </>
  );
};
export default ExternalTypeSelectionScreen;
